export default __webpack_public_path__ + "static/media/miracle_3.8cd78c5b.jpg";